import { FC, ReactNode } from 'react';

interface SearchFilterSectionLabelProps {
    icon: ReactNode;
    label: ReactNode;
}

const SearchFilterSectionLabel: FC<SearchFilterSectionLabelProps> = ({ icon, label }) => (
    <span
        style={{
            alignItems: 'center',
            display: 'inline-flex',
            gap: '0.375rem',
            lineHeight: '1.25rem',
            minWidth: 0,
        }}
    >
        <span
            aria-hidden
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                flex: '0 0 1rem',
                fontSize: '1rem',
                height: '1rem',
                justifyContent: 'center',
                lineHeight: 0,
                width: '1rem',
            }}
        >
            {icon}
        </span>
        <span style={{ minWidth: 0 }}>{label}</span>
    </span>
);

export default SearchFilterSectionLabel;
